import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-dashboard',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-dashboard works!</p> `,
  styles: ``,
})
export class CpDashboardComponent {}
